












































































import {
    computed,
    defineComponent,
    PropType,
    toRef,
} from '@vue/composition-api';
import EventCardTitle from './EventCardTitle.vue';
import Event from './Event.vue';
import EventCardDivider from './EventCardDivider.vue';
import OddOffer from './OddOffer.vue';
import OfferEvent from '@core/models/offer/OfferEvent';
import Market from '@core/models/offer/Market';
import BetBuilderEventCardLink from '@sportOfferFederation/bet-builder/links/BetBuilderEventCardLink.vue';
import { EventCardSource } from '@app/enums';
import { OddValueDynamics } from '@store/modules/data/sportOffer/types';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import PreferencesStore from '@store/modules/ui/user/preferences/preferencesIndex';
import { SportOfferStore } from '@store/modules/ui/sportOffer/sportPage/sportPageIndex';
import { useEventObserver } from '@shared/composables/feedPersonalizationAnalytics/useEventObserver';
import { useAnalytics } from '@sportOfferFederation/bet-builder/store/composition/useAnalytics';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { ClickName } from '@superbet-group/product.analytics';
import { useBBEventCardLabeling } from '@sportOfferFederation/bet-builder/composables/useBBEventCardLabeling';
import EventBettorNumber from './EventBettorNumber.vue';
import { NavigationDataStore } from '@store/modules/navigation';

import { PeerUrgencyExperimentVariant } from '@core/models/user/flags';
export default defineComponent({
    name: 'EventCard',
    emits: [
        'pinClick',
        'oddClick',
    ],
    props: {
        event: {
            type: Object as PropType<OfferEvent>,
            required: true,
        },
        expandedEvent: {
            type: Number,
            default: null,
        },
        isForceVerticalAligned: {
            type: Boolean,
            required: false,
            default: false,
        },
        market: {
            type: Object as PropType<Market | null>,
            default: null,
        },
        oddValueDynamics: {
            type: Object as PropType<OddValueDynamics>,
            required: false,
            default: undefined,
        },
        selectedOdds: {
            type: Set as PropType<Set<string>>,
            default: () => new Set(),
        },
        isPrimaryMarketSelected: {
            type: Boolean,
            default: true,
        },
        isPinShown: {
            type: Boolean,
            default: true,
        },
        showTitle: {
            type: Boolean,
            default: false,
        },
        eventCardSource: {
            type: String as PropType<EventCardSource>,
            required: true,
        },
        bettorNumber: {
            type: Number as PropType<number>,
            required: false,
            default: -1,
        },
        socialProofDesignVariant: {
            type: String as PropType<PeerUrgencyExperimentVariant>,
            required: false,
            default: PeerUrgencyExperimentVariant.None,
        },
    },
    setup(props, { emit }) {
        const navigationStore = useVuexStore<NavigationDataStore>('navigation');
        const preferencesStore = useVuexStore<typeof PreferencesStore>('ui/user/preferences');
        const sportOfferStore = useVuexStore<SportOfferStore>('ui/sportOffer');

        const event = toRef(props, 'event');
        const { isBBEventCardLabelVisible, route } = useBBEventCardLabeling(event);

        const activeQuickFilter = sportOfferStore.getter('activeQuickFilter');

        const { observedElementRef, visibleEvents } = useEventObserver();

        const teams = computed(() => {
            return {
                homeTeam: props.event.team1Name,
                awayTeam: props.event.team2Name,
            };
        });

        function pinClick() {
            emit('pinClick', props.event.id);
        }

        const handleClick = (event: MouseEvent) => {
            // clicking on odd doesnt open match details page
            if ((event.target as Element).className?.includes('odd-button')) { return; }
            AnalyticsSDK.getInstance().log('click', {
                click_name: ClickName.CLICK_NAME_UNSPECIFIED,
                click: {
                    click_name: 'feed_personalisation_match_details_click',
                    click_value_1: props.event.uuid,
                    click_value_2: visibleEvents.value.filter((id) => id !== props.event.uuid).toString(),
                    click_value_3: activeQuickFilter.value,
                    type: 'test_click',
                },
            });
        };

        const { betBuilderEventCardLabelClicked } = useAnalytics();

        function handleBetBuilderEventCardLinkClick() {
            betBuilderEventCardLabelClicked({ eventId: props.event.id, source: props.eventCardSource });
        }

        return {
            isOnHomePage: navigationStore.getter('isOnHomePage'),
            isBBEventCardLabelVisible,
            route,
            teams,
            isEventPinned: computed(() => {
                return preferencesStore.getter('pinnedEventIds').value.includes(props.event.id);
            }),
            pinClick,
            observedElementRef,
            handleClick,
            handleBetBuilderEventCardLinkClick,
        };
    },
    components: {
        BetBuilderEventCardLink,
        EventCardTitle,
        Event,
        EventCardDivider,
        OddOffer,
        EventBettorNumber,
    },
});
